import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation("footer");

  return (
    <footer className="border-t border-[#E5E5E5] bg-[#F9F9F9]">
      <div className="mx-auto grid max-w-[1380px] gap-10 px-4 py-12 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
        {/* Contact Information */}
        <div className="space-y-4">
          <h2 className="text-lg font-semibold text-[#414141]">{t("contact.title")}</h2>
          <p className="text-sm font-semibold text-[#414141]">{t("contact.company")}</p>
          <p className="text-sm text-[#6E6E6E]">{t("contact.hub")}</p>
          <p className="text-sm text-[#6E6E6E]">{t("contact.headquarters")}</p>
          <p className="text-sm text-[#6E6E6E]">{t("contact.serving")}</p>

          {/* Social Icons - ONLY LinkedIn visible */}
          <div className="flex items-center gap-4 mt-6">
            <a
              href="https://www.linkedin.com/company/kirusa/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-[#0077B5] hover:text-[#005582] transition-colors focus:outline-none focus:ring-2 focus:ring-[#0077B5]/30 rounded"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="drop-shadow-sm"
                aria-hidden="true"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>

            {/* Other social icons remain hidden as requested */}
            <a
              href="https://www.facebook.com/KirusaInc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-facebook"
                viewBox="0 0 16 16"
              >
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.994 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/kirusa_channels/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-instagram"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.89.923-1.417.197-.509.332-1.09.371-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 12.24.42c-.509-.198-1.09-.333-1.942-.371C10.445.01 10.173 0 8 0m0 1.44c2.136 0 2.39.009 3.233.048.78.036 1.203.166 1.485.276.374.145.64.319.92.599.28.28.453.546.598.92.11.282.24.705.276 1.485.039.843.048 1.097.048 3.234s-.009 2.39-.048 3.233c-.036.78-.166 1.203-.276 1.485-.145.374-.319.64-.599.92-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.843.039-1.097.048-3.233.048s-2.39-.009-3.233-.048c-.78-.036-1.203-.166-1.485-.276a2.48 2.48 0 0 1-.92-.598 2.48 2.48 0 0 1-.598-.92c-.11-.282-.24-.705-.276-1.485C1.45 10.39 1.44 10.136 1.44 8s.009-2.39.048-3.233c.036-.78.166-1.203.276-1.485.145-.374.319-.64.598-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276C5.61 1.45 5.864 1.44 8 1.44m0 2.452a4.108 4.108 0 1 0 0 8.216 4.108 4.108 0 0 0 0-8.216m0 6.775a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334m5.29-6.713a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0" />
              </svg>
            </a>
            <a
              href="https://x.com/KirusaInc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
              className="hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-twitter-x"
                viewBox="0 0 16 16"
              >
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.6.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@kirusainc.1911"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-youtube"
                viewBox="0 0 16 16"
              >
                <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.441-.185-1.11-.242-1.95l-.07-1.073-.07-1.074v-.103c.002-.57.014-1.14.067-1.658.05-.575.124-1.14.235-1.558a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 8.05 2Zm-.17 4.12v4.745l4.131-2.372z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Products */}
        <div className="space-y-3">
          <h2 className="text-lg font-semibold text-[#414141]">{t("products.title")}</h2>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="https://www.convobuddy.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("products.convobuddy")}
          </a>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="https://corpusio.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("products.corpusio")}
          </a>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="https://happyfit.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("products.happyfit")}
          </a>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="https://melodycrafters.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("products.melodycrafters")}
          </a>
        </div>

        {/* Resources */}
        <div className="space-y-3">
          <h2 className="text-lg font-semibold text-[#414141]">{t("resources.title")}</h2>
          <Link
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            to="/faq"
          >
            {t("resources.faq")}
          </Link>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="/static/documentation.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("resources.documentation")}
          </a>
          <Link
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            to="/support"
          >
            {t("resources.support")}
          </Link>
        </div>

        {/* Company */}
        <div className="space-y-3">
          <h2 className="text-lg font-semibold text-[#414141]">{t("company.title")}</h2>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="https://kirusa.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("company.about")}
          </a>
          <span className="block text-sm text-[#6E6E6E]">
            {t("company.careers")}
          </span>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="/static/privacy_policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("company.privacyPolicy")}
          </a>
          <a
            className="block text-sm text-[#414141] transition hover:text-[#D81F26]"
            href="/static/terms_of_service.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("company.termsOfService")}
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#E5E5E5] py-4 text-center text-sm text-[#6E6E6E]">
        {t("copyright")}
      </div>
    </footer>
  );
}